<template>
  <transition name="custom-modal">
        <div class="m-mask">
          <div class="m-wrapper">
            <div class="m-container">

              <div class="m-header">
                <h5 v-if="!slotConfirmed">Choose interview slot on {{formatDate(slotData.startDate)}}</h5>
                <h5 v-if="slotConfirmed">Interview Confirmed</h5>
              </div>

              <div class="m-body">
                <ul v-if="!slotConfirmed">
                  <li v-for="slot in slots" :key="slot._id">
                    <span>
                      {{formatTime(slot.timeStart)}} - {{formatTime(slot.timeEnd)}} {{slot.branch ? `at our ${slot.branch} branch` : ''}}
                    </span>
                    <b-button size="sm" class="m-1" variant="info" @click="handleSelection(slot)">
                      Confirm Booking
                    </b-button>
                  </li>
                </ul>
                <p class="text-small" v-if="!slotConfirmed">Please note you will not be able to amend this time slot.</p>
                <b-button size="sm" class="mt-3" v-if="!slotConfirmed" @click="$emit('close')">
                  Choose another day
                </b-button>
              </div>

              <div class="m-footer">
                  <b-alert v-show="submitSuccess" variant="success" show>
                    <p>Your interview slot has been booked. You will now be redirected to the holding page and should receive an email confirming the details.</p>
                  </b-alert>
                  <b-alert v-show="submitError" variant="danger" show>
                    <p>There was a problem booking your slot, please try again later.</p>
                  </b-alert>
              </div>
            </div>
          </div>
        </div>
  </transition>
</template>

<script>
import moment from 'moment'
import { getInterviewSlotsDay } from '../../services/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    modalId: {
      type: String,
      required: true
    },
    slotData: {
      type: Object
    },
    submitSuccess: {
      type: Boolean
    },
    submitError: {
      type: Boolean
    },
    calendar: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getToken: 'authStore/getToken',
      getRecruit: 'authStore/getRecruit'
    }),
  },
  data () {
    return {
      day: '',
      month: '',
      year: '',
      slots: [],
      slotConfirmed: false
    }
  },
  mounted () {
    this.day = moment(this.slotData.startDate).format('DD')
    this.month = moment(this.slotData.startDate).format('MM')
    this.year = moment(this.slotData.startDate).format('YYYY')
    this.loadDaySlots()
  },
  methods: {
    async loadDaySlots() {
      this.slots = []
      const res = await getInterviewSlotsDay({
        day: this.day,
        month: this.month,
        year: this.year
      })
      if (res && res.data.slots && res.data.slots.length && this.calendar === 'f2f') {
        this.slots = res.data.slots.filter(s => s.type === this.calendar && this.getRecruit.centres.includes(s.branch))
      }
      if (res && res.data.slots && res.data.slots.length && this.calendar === 'phone') {
        this.slots = res.data.slots.filter(s => s.type === this.calendar)
      }
    },
    formatDate(date) {
      return moment(date).format('D MMM YYYY')
    },
    formatTime(date) {
      return moment(date).format('HH:mm')
    },
    handleSelection (slot) {
      this.slotConfirmed = true
      this.$emit('bookSlot', slot.slotId)
    }
  }  
}
</script>

<style scoped>
.m-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.m-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.m-container {
  width: 90%;
  margin: 0px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
@media only screen and (min-width: 992px) {
  .m-container {
    width: 50%;
  }
}

.m-header h3 {
  margin-top: 0;
  color: #42b983;
}

.m-body {
  margin: 20px 0;
}
.m-footer {
  display: flex;
  flex-direction: column;
}

.modal-default-button {
  width: 100%;
  background-color: rgb(55, 177, 31);
  border: none;
  padding: 10px;
  color: #fff;
}
.modal-close-button {
  width: 100%;
  background-color: rgb(177, 31, 31);
  border: none;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
}
.modal-book-button {
  width: 190px;
  background-color: rgb(55, 177, 31);
  border: none;
  padding: 4px;
  color: #fff;
  margin: 1px 0 1px 6px;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
